import { isImageFileName } from "../schemas/chat-message-files";

const localImageUrlByStorageUrl = new Map<string, string>();

export function rememberLocalImage(storageUrl: string | null | undefined, file: File): void {
  if (!storageUrl || !isImageFileName(file.name) || localImageUrlByStorageUrl.has(storageUrl)) return;
  localImageUrlByStorageUrl.set(storageUrl, URL.createObjectURL(file));
}

export function localImageUrl(storageUrl: string): string | undefined {
  return localImageUrlByStorageUrl.get(storageUrl);
}
